function variantsWithOptionValues(product, selected_option_values, option_index0, value) {
  var values_to_match = [];
  selected_option_values.forEach((v, vIndex) => {
    if (vIndex < option_index0) {
      values_to_match.push(v);
    }
    else if(vIndex == option_index0) {
      values_to_match.push(value);
    }
  });

  var matching_variants = product.variants.filter(v => {
    var v_options_to_match = v.options.filter((o, index) => index <= option_index0);
    return _.difference(v_options_to_match, values_to_match).length == 0;
  });

  var leading_variants = matching_variants.filter(v => {
    return selected_option_values.length > 1 ? _.intersection(selected_option_values, v.options).length > 0 : true;
  });
  //console.log({value, values_to_match, matching_variants, leading_variants});

  var is_sold_out = leading_variants.length && (leading_variants.filter(v => !v.available).length == leading_variants.length);
  if (!product.available) {
    is_sold_out = true;
  }

  return {value, values_to_match, matching_variants, leading_variants, is_sold_out};
}

(() => {
  let ProductLinkedOptions = () => {
    let getProductJson = ($form) => {
      let $data_product = $form.querySelector('[data-product-json-data]');
      if (!$data_product) return null;

      let product = JSON.parse($data_product.querySelector('[data-product-json]').value);
      let options_with_values = JSON.parse($data_product.querySelector('[data-product-options-with-values-json]').value);
      let selected_variant = JSON.parse($data_product.querySelector('[data-selected-variant-json]').value);
      product.options_with_values = options_with_values;
      product.selected_variant = selected_variant;

      return product;
    }

    let LinkedOptions = ($form, product) => {
      //console.log(product.selected_variant);
      setTimeout(() => {
        let form_selected_values = Array.from($form.querySelectorAll('input:checked')).map($item => $item.value);
        // go through each swatch
        $form.querySelectorAll('.product_swatch_options .swatch-element').forEach(($swatch) => {
          let option_index0 = $swatch.closest('.swatch').dataset.optionIndex;
          let value = $swatch.dataset.value;
          let selected_option_values = product.selected_variant ? product.selected_variant.options : form_selected_values;
          if (selected_option_values.length !== product.options_with_values.length) {
            let first_option_selected_value = selected_option_values[0];
            let first_leading_variant = product.variants.find(v => _.intersection(v.options, [first_option_selected_value]).length > 0);
            selected_option_values = first_leading_variant.options;
          }
          let value_Variants = variantsWithOptionValues(product, selected_option_values, option_index0, value);
          let value_LeadingVariants = value_Variants.leading_variants;
  
          $swatch.classList.toggle('soldout', value_Variants.is_sold_out);
          $swatch.classList.toggle('available', !value_Variants.is_sold_out);
  
          // First Option
          if (option_index0 == 0) {
          }
          else {
            $swatch.classList.toggle('hide', value_LeadingVariants.length == 0);
            $swatch.classList.toggle('not-leading', value_LeadingVariants.length == 0);
          }
        });
  
        // If all options hidden, hide Swatch category
        $form.querySelectorAll('.product_swatch_options .swatch').forEach(($category) => {
          let $swatches_visible = $category.querySelectorAll('.swatch-element:not(.hide)');
          let $swatches_available = $category.querySelectorAll('.swatch-element:not(.hide):not(.soldout):not(.not-leading)');
          let $swatches_leading = $category.querySelectorAll('.swatch-element:not(.not-leading)');
          let hideSwatches = $swatches_visible.length <= 1;
          $category.classList.toggle('hide', hideSwatches);
  
          // if only 1 available option, pre-select
          if ($swatches_available.length == 1 || $swatches_leading.length == 1) {
            $category.dataset.userSelected = true;
            let $swatch = $swatches_available[0] || $swatches_leading[0];
            let value_handle = $swatch.dataset.valueHandle;
            let $radio = $swatch.closest('.swatch').querySelector(`input[type=radio][data-value-handle=${ value_handle }]`);
            if (!$radio.checked) {
              setTimeout(() => {
                $radio.checked = true;
                $radio.dispatchEvent(new Event('change', {bubbles: true}));
              }, 0);
            }
          }
        });  
      }, 0);

      setTimeout(() => {
        let $unselectedCategories = $form.querySelectorAll('.product_swatch_options .swatch[data-user-selected="false"]');
        $unselectedCategories.forEach(($category, categoryIndex) => {
          if (categoryIndex !== 0) {
            $category.classList.add('hide');
          }
          else if (categoryIndex == 0) {
            let $swatches_available = $category.querySelectorAll('.swatch-element:not(.hide):not(.soldout)');
    
            if ($swatches_available.length > 1) {
              $category.querySelectorAll('input[type=radio]').forEach(($radio) => {
                  $radio.checked = false;
              });  
            }
          }
        });
      }, 0);

      // If not all options selected, prompt user to select options
      setTimeout(() => {
        let $unselectedCategories = $form.querySelectorAll('.product_swatch_options .swatch[data-user-selected="false"]');
        let AllOptionsSelected = $unselectedCategories.length == 0;

        let categoryTitle;
        let $promptCategories = Array.from($form.querySelectorAll('.product_swatch_options .swatch')).filter(($category) => {
          return !$category.classList.contains('hide');
        });
        
        if ($promptCategories.length) {
          let recent = $promptCategories.length - 1;
          let categoryPromptIndex = $promptCategories[recent].dataset.optionIndex;
          categoryTitle = product.options_with_values[categoryPromptIndex].name;
        }
  
        let $atc_btn = $form.querySelector('.button--add-to-cart');
        if ($atc_btn) {
          $atc_btn.disabled = !AllOptionsSelected;
          let prompt_title = categoryTitle ? `Select - ${ categoryTitle }` : 'Select options';
          if (AllOptionsSelected && product.selected_variant) {
            $atc_btn.querySelector('.text').innerText = product.selected_variant.available ? 'Add To Cart' : 'Sold Out';
            $atc_btn.disabled = !product.selected_variant.available;
          }
          else {
            $atc_btn.querySelector('.text').innerText = prompt_title;
          }  
        }
      }, 0);

      if (!product.selected_variant) {
        console.error('NO VARIANT')
      }
    }

    // on variant-change
    document.addEventListener('variant:change', (e) => {
      //console.log(e);
      let $form = document.querySelector(`#product_form_${ e.detail.selector.product.id }`);
      let product = getProductJson($form);
      let variant = e.detail.variant;
      product.selected_variant = variant;
      LinkedOptions($form, product);
    });

    // Swatch show/hide with product variants
    document.querySelectorAll('.shopify-product-form').forEach(($form) => {
      let $form_wrap = $form.closest('.product_form');
      let show_options_in_steps = JSON.parse($form_wrap.dataset.show_options_in_steps);
      if (!show_options_in_steps) {
        return;
      }
    
      $form.querySelectorAll('.swatch').forEach(($category) => {
        $category.dataset.userSelected = false;
      });
      $form.querySelectorAll('input[type=radio]').forEach(($radio) => {
        $radio.addEventListener('change', (e) => {
          let $swatch = e.currentTarget;
          let $category = $swatch.closest('.swatch')
          $category.dataset.userSelected = true;

          // unselect subsequent categories
          let option_index0 = JSON.parse($category.dataset.optionIndex);
          $form.querySelectorAll('.product_swatch_options .swatch').forEach(($category, categoryIndex) => {
            if (categoryIndex > option_index0) {
              $category.dataset.userSelected = false;
            }
          });
        });
      });
    });
  }

  let DOMReady = () => {
    ProductLinkedOptions();
  }

  document.addEventListener('DOMContentLoaded', DOMReady);
})();